module.exports = __webpack_public_path__ + "img/IconWifi.6c678d04.svg";